import React from "react";
import { useTranslation } from "react-i18next";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import { useAppConfig } from "common/providers/AppConfigProvider";
import { useAuth } from "common/hooks/useAuth";

function LicenseBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isLicenceValid, isLicenceSoonToExpire, isLoading } = useAppConfig();
  const { user: currentUser } = useAuth();

  // Don't show banner while loading or if license is valid and not expiring soon
  if (isLoading || (isLicenceValid && !isLicenceSoonToExpire)) {
    return null;
  }

  const isInvalid = !isLicenceValid;
  const bgColor = isInvalid ? "bg-red-600" : "bg-yellow-600";
  const title = isInvalid
    ? t("license.invalidTitle")
    : t("license.soonExpireTitle");
  const message = isInvalid
    ? t("license.invalidMessage")
    : t("license.soonExpireMessage");

  const handleGoToSettings = () => {
    navigate("/servers");
  };

  return (
    <div
      className={`${bgColor} text-white px-4 py-3 flex items-center justify-between shadow-md`}
    >
      <div className="flex items-center flex-1">
        <ExclamationCircleIcon className="w-5 h-5 mr-3 flex-shrink-0" />
        <div className="flex-1">
          <p className="font-semibold text-sm">{title}</p>
          <p className="text-xs mt-1 opacity-90">{message}</p>
        </div>
      </div>

      {/* Bouton uniquement si authentifié */}
      {currentUser && (
        <button
          onClick={handleGoToSettings}
          className="ml-4 px-4 py-2 bg-white/20 hover:bg-white/30 rounded text-sm font-medium transition-colors flex-shrink-0"
        >
          {t("license.goToSettings")}
        </button>
      )}
    </div>
  );
}

export default LicenseBanner;
